<i18n>
{
  "fr": {
    "slice-document-download": "Télécharger"
  },
  "en": {
    "slice-document-download": "Download"
  }
}
</i18n>

<template>
  <div class="mb-24px">
    <hr class="is-marginless" />
    <div v-for="(item, index) of items" :key="index">
      <div class="level my-12px">
        <div class="level-left" style="flex-shrink: 1">
          <prismic-rich-text class="content is-custom is-marginless" :field="item.document_content" />
        </div>
        <div v-if="item.document_media && item.document_media.url" class="level-right" :class="{ 'ml-12px': $media.tablet }">
          <b-button tag="a" :href="item.document_media.url" target="_blank" type="is-link" icon-left="arrow-down" outlined>{{
            $t('slice-document-download')
          }}</b-button>
        </div>
      </div>
      <hr class="is-marginless" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fragment: Object
  },
  computed: {
    items() {
      return this.fragment.items.filter((x) => this.$prismicText(x.document_content) || x.document_media.url)
    }
  }
}
</script>
